import { Box, styled } from '@mui/material';
import color from 'src/theme/color';

export const SpinnerContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 120px 0;
    gap: 24px;
`;

export const SpinnerText = {
    font: '500 14px/17px "Inter",sans-serif',
    color: color.white50
};

export const spinnerProgressSx = {
    color: color.lightningYellow
};
